module.exports = __webpack_public_path__ + "static/img/rank_67.f0d4eda.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_67.png
// module id = 7ngu
// module chunks = 1